/* @ngInject */
export default function SmartlockService($q, $log, $sails, EquipmentInfoService) {
  const service = this;

  const DATA = 'data';
  const QC = 'quickClicks';
  const CODES = 'codes';

  /**
   * Public Variables
   */
  service.equipmentModel = {};

  /**
   * Public Methods
   */
  service.getEquipmentFromIds = getEquipmentFromIds;
  service.requestCode = requestCode;
  service.revokeCode = revokeCode;
  service.deleteModel = deleteModel;


  function getEquipmentFromIds(panelId, equipmentIds) {
    return EquipmentInfoService
      .getFullEquipment(equipmentIds)
      .then(equipment => setupModel(panelId, equipment))
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error);
      });
  }

  /**
   * Retrieves codes from given model
   *
   * @param {object} model Either an equipment model or a padlock data object
   * TODO : @param {boolean} formatted Whether to pretty the codes
   * @returns {?object} codes, if any
   */
  function getCodes(model) {
    const data = model.data || model;
    return _.get(data, [QC, CODES]);
  }

  /**
   * Adds code and pretty-code to model
   *
   * @param {object} code Code
   * @param {string} code.code (Literal) code must be passed containing its key
   * @param {object} equipment Model
   * @returns {undefined}
   */
  function addCode(code, equipment) {
    const path = [DATA, QC, CODES];
    const codes = _.get(equipment.eq, path, {});
    // if the 'codes' object doesn't already exist on the eq, use _.set here to create it while maintaining
    // the reference to the original eq object so it's updated everywhere.
    _.set(equipment.eq, path, _.merge(codes, code));

    if (code.assigned && !code.revoked) {
      equipment.formattedQCs.codes.push({
        ...code,
        prettyCode: formatQC(code.code),
      });
    }
  }

  function delCode(code, equipment) {
    const { eq, formattedQCs } = equipment;
    eq.data.quickClicks.codes[code] = undefined;
    _.remove(formattedQCs.codes, { code });
  }

  /**
   * TODO: Will replace this with shared typedef
   *
   * @param {object} data ~
   * @param {string} data.name ~
   * @param {string} data.phone ~
   * @param {string} data.type ~
   * @param {object} equipmentModel ~
   * @returns {Promise<string>} New code (formatted)
   */
  function requestCode(data, equipmentModel) {
    return $sails
      .post('/integration/noke/quickclick', data)
      .then(({ data: padlock }) => {
        const newCode = getCodes(padlock);
        // * If scratching head, remember we are dealing with
        // * the annoying fact that the (raw) code is the key of the code object
        _.forEach(newCode, (obj, code) => addCode({ ...obj, code }, equipmentModel));
        return formatQC(_.first(_.keys(newCode)));
      })
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error);
      });
  }

  /**
   * @param {string} code Code to be revoked
   * @param {string} equipmentId ID of smartlock equipment
   * @param {string} panel ID of panel making request
   * @returns {Promise<Array<object>>} New panel model
   */
  function revokeCode(code, equipmentId, panel) {
    return $sails
      .post('/integration/noke/quickclick/revoke', { code, equipmentId })
      .then(() => {
        const model = _.find(service.equipmentModel[panel], ['eq.id', equipmentId]);
        delCode(code, model);
        return service.equipmentModel[panel];
      });
  }

  function deleteModel(panelId) {
    delete service.equipmentModel[panelId];
  }

  function setupModel(panelId, equipment) {
    service.equipmentModel[panelId] = _.map(equipment, eq => ({
      eq,
      formattedQCs: {
        [CODES]: _.reduce(getCodes(eq), (acc, obj, code) => {
          if (obj.assigned && !obj.revoked) {
            acc.push({
              ...obj,
              code,
              prettyCode: formatQC(code)
            });
          }
          return acc;
        }, []),
      }
    }));
    return service.equipmentModel[panelId];
  }

  function formatQC(qc, chunkSize = 4, separator = '-') {
    const mapper = {
      0: 'S',
      1: 'L'
    };
    return _.reduce(
      qc,
      (acc, val, idx) => `${acc}${idx && !(idx % chunkSize) ? separator : ''}${mapper[val]}`,
      ''
    );
  }
}
